export { default } from './PaginationButton';



// WEBPACK FOOTER //
// ./src/components/atoms/PaginationButton/index.js